import React, {useState, useEffect, Fragment} from "react";
import styled from "styled-components";
import iconDrop from "assets/icons/icon_drop_black.svg";

export const PaymentForm = (props) => {
	return (
		<Wrapper {...props}>
			{props.children}
		</Wrapper>
	);
};

const Wrapper = styled.div`
&						{padding:24px}
.title					{padding-bottom:25px; border-bottom:1px solid var(--lightBorder)}
.title h2				{font-weight:600}
.title h5				{margin-bottom:8px}
.title + div			{padding:22px 0}
.badge					{padding:8px 10px; font-size:var(--14px)}

h4						{margin-bottom:15px; font-size:var(--16px)}
li						{display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap}
li + li					{margin-top:12px}
li > div:first-child	{font-size:var(--14px); color:var(--gray50)}
li > div + div			{text-align:right; font-weight:500}
li ul					{position:relative; margin-top:10px; padding-left:10px; width:100%; overflow:hidden; font-size:var(--14px)}
li ul:before			{content:""; position:absolute; left:0; top:2px; bottom:2px; width:2px; background-color:var(--border)}
li li div + div			{font-size:var(--14px)}

li div.drop				{position:relative; padding:0 1.25em 0 0.5em}
li div.drop:after		{content:""; position:absolute; right:0; top:0; bottom:0; width:1em; background:url(${iconDrop}) no-repeat center center / 0.675em}
li div.drop.focus:after	{transform:rotate(-180deg)}
li div.drop + ul		{margin-top:0; height:0}
li div.drop.focus + ul	{margin-top:10px; height:auto}

`;

export default PaymentForm;